import { UNLIMITED } from "./unlimited";

export const FILTER_NAMES = {
  brand: "brand",
  contractTermInMonths: "contractTermInMonths",
  currentProvider: "currentProvider",
  dataCredits: "dataCredits",
  dataSpeedDown: "dataSpeedDown",
  dataSpeedGen: "dataSpeedGen",
  monthlyFee: "monthlyFee",
  offerExtraGroups: "offerExtraGroups",
  phoneOperatingSystem: "phoneOperatingSystem",
  price: "price",
  providers: "providers",
  voiceCredits: "voiceCredits"
};

export const DEFAULT_DATA_CREDITS_VALUE_MAP = {
  0: 0,
  1: 100,
  2: 200,
  3: 300,
  4: 400,
  5: 500,
  6: 1000,
  7: 1500,
  8: 2000,
  9: 2500,
  10: 3000,
  11: 4000,
  12: 5000,
  13: 10000,
  14: 20000,
  15: 30000,
  16: 40000,
  17: 50000,
  18: 60000,
  19: 70000,
  20: 80000,
  21: 90000,
  22: 100000,
  23: 110000,
  24: 120000,
  25: 130000,
  26: 140000,
  27: 150000,
  28: UNLIMITED
};

export const DEFAULT_DATA_SPEED_DOWN_VALUE_MAP = {
  0: 0,
  1: 10,
  2: 20,
  3: 30,
  4: 40,
  5: 50,
  6: 60,
  7: 70,
  8: 80,
  9: 90,
  10: 100,
  11: 110,
  12: 120,
  13: 130,
  14: 140,
  15: 150,
  16: 200,
  17: 250,
  18: 300,
  19: 350,
  20: 400,
  21: 450,
  22: 500,
  23: 600,
  24: 700,
  25: 800,
  26: 900,
  27: 1000
};

export const DEFAULT_MONTHLY_FEE_VALUE_MAP = {
  0: 0,
  1: 5,
  2: 10,
  3: 15,
  4: 20,
  5: 25,
  6: 30,
  7: 35,
  8: 40,
  9: 45,
  10: 50,
  11: 55,
  12: 60,
  13: 65,
  14: 70,
  15: 75,
  16: 80,
  17: 85,
  18: 90,
  19: 95,
  20: 100,
  21: 105,
  22: 110,
  23: 115,
  24: 120,
  25: 125,
  26: 130,
  27: 135,
  28: 140,
  29: 145,
  30: 150
};

export const DEFAULT_PRICE_VALUE_MAP = {
  0: 0,
  1: 10,
  2: 20,
  3: 30,
  4: 40,
  5: 50,
  6: 60,
  7: 70,
  8: 80,
  9: 90,
  10: 100,
  11: 125,
  12: 150,
  13: 160,
  14: 170,
  15: 180,
  16: 190,
  17: 200,
  18: 250,
  19: 300,
  20: 350,
  21: 400,
  22: 450,
  23: 500,
  24: 600,
  25: 700,
  26: 750,
  27: 800,
  28: 900,
  29: 1000,
  30: 1100,
  31: 1200,
  32: 1300,
  33: 1400,
  34: 1500,
  35: 1600,
  36: 1700,
  37: 1800,
  38: 1900,
  39: 2000,
  40: 2100,
  41: 2200,
  42: 2300,
  43: 2400,
  44: 2500
};

export const DEFAULT_VOICE_CREDITS_VALUE_MAP = {
  0: 0,
  1: 10,
  2: 20,
  3: 30,
  4: 40,
  5: 50,
  6: 60,
  7: 70,
  8: 80,
  9: 90,
  10: 100,
  11: 120,
  12: 150,
  13: 200,
  14: 300,
  15: 400,
  16: 500,
  17: 1000,
  18: 1200,
  19: 1500,
  20: 1800,
  21: 2400,
  22: 3000,
  23: 4000,
  24: 5000,
  25: 6000,
  26: 7000,
  27: 8000,
  28: 9000,
  29: 10000,
  30: UNLIMITED
};
